interface ISettings {
  apiUrl: string;
  baseName: string;
  language: string;
  copyYear: string;
}

const getSettings = (): ISettings => {
  var request = new XMLHttpRequest();
  const url = process.env.PUBLIC_URL + "/appsettings.json";
  request.open("GET", url, false);
  request.send(null);
  if (request.status === 200)
    return JSON.parse(request.response) as ISettings;
  return {} as ISettings;
};
export const { apiUrl, baseName, language, copyYear } = getSettings();
